import { render, staticRenderFns } from "./PlantFieldDataForm.vue?vue&type=template&id=d9880c92&"
import script from "./PlantFieldDataForm.vue?vue&type=script&lang=ts&"
export * from "./PlantFieldDataForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports